import { __assign, __rest } from "tslib";
import React, { useRef, useContext } from 'react';
import { ScreenSizeContext } from '../Measured/ScreenSizeContext';
import { useMeasuredCookie } from '../Measured/useMeasuredCookie';
import { default as Grid } from './Grid';
var MeasuredGrid = function (_a) {
    var cookieType = _a.cookieType, gridProps = __rest(_a, ["cookieType"]);
    var screenWidth = useContext(ScreenSizeContext).width;
    var containerRef = useRef(null);
    var sentinelRef = useRef(null);
    var measuredContainer = useMeasuredCookie(cookieType, containerRef, {
        cookieDim: 'width',
        listenOnWindow: true,
        sentinelRef: sentinelRef,
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: sentinelRef, style: { maxWidth: '100%' } }),
        React.createElement("div", { ref: containerRef },
            React.createElement(Grid, __assign({}, gridProps, { screenWidth: screenWidth, containerWidth: measuredContainer === null || measuredContainer === void 0 ? void 0 : measuredContainer.width })))));
};
MeasuredGrid.displayName = 'MeasuredGrid';
export default MeasuredGrid;
//# sourceMappingURL=MeasuredGrid.js.map